// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Ku2p","title":"ClientInsurance_title__3409i","itemText":"ClientInsurance_itemText__lmw4W"};